var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var BackspaceIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M8.04 19c-.542 0-1.022-.275-1.351-.774L2.66 12l4.028-6.232C7.015 5.272 7.495 5 8.04 5h10.93c.932 0 1.69.782 1.69 1.743v10.514c0 .961-.758 1.743-1.69 1.743H8.04Zm1.424-9.068 1.445-1.444 2.11 2.11 2.111-2.131L16.564 9.9l-2.122 2.121 2.133 2.132-1.445 1.445-2.132-2.132-2.084 2.084-1.418-1.424 2.069-2.094-2.1-2.1Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default BackspaceIcon;
